import {
  AddOutlined,
  ArrowForwardIosOutlined,
  DeleteForeverOutlined,
  DisplaySettingsOutlined,
  DragHandleOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Offcanvas,
  OverlayTrigger,
  Tab,
  Table,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import { toast } from "react-hot-toast";
import { idGenerator } from "../../helpers/idGenerator";
import useForm from "../../hooks/useForm";
import useHome from "../../hooks/useHome";
import useInTheWorld from "../../hooks/useInTheWorld";
import usePgiModules from "../../hooks/useModules";
import InTheWorldReplica from "./editComponents/InTheWorldReplica";

function InTheWorldPgi() {
  const [selectBanner, setSelectBanner] = useState(false);
  const [modulesNew, setModulesNew] = useState(null)
  const { inTheWorld, editWorld } = useInTheWorld();
  const { banners, handleVisibilityBanners, bloques, handleVisibilityBloque } = useHome();
  const {
    modules,
    setModules,
    getModulesByParams,
    handleVisibility,
    handleModuleUpdate,
  } = usePgiModules();
  const { values, setValues, handleInputChange } = useForm({
    state: true,
    publish: false,
    title: "",
  });
  const [showEditProducto, setShowEditProducto] = useState(true);
  const [selectBloque, setSelectBloque] = useState(false);
  const handleClose = () => setShowEditProducto(false);
  const handleShow = () => setShowEditProducto(true);

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setModules(res.sort((a, b) => a.position - b.position));
    });
    document.title = "Personalizar En el mundo | PGI Tensolite"; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setModulesNew(modules?.filter(
      (module) =>
        module?.title === "Carrousel_deLinea" || module?.title === "Carrousel_especial" || module?.title === "Banner_publicitario" || module?.title === "Bloque_info"
    ))

  }, [modules])

  useEffect(() => {
    setValues(inTheWorld);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inTheWorld]);

  const arrayBanner = banners?.find((banner) => banner.state === true);

  const handleAddStep = () => {
    setValues({
      ...values,
      locations: [
        ...values?.locations,
        {
          _id: idGenerator(12),
          title: "",
        },
      ],
    });
  };

  const handleStepInput = ({ target }) => {
    setValues({
      ...values,
      locations: values.locations.map((step, i) => {
        if (step._id === target.id) {
          if (target.name === "lng" || target.name === "lat") {
            return {
              ...step,
              position: { ...step.position, [target.name]: target.value },
            };
          } else {
            return { ...step, [target.name]: target.value };
          }
        }
        return step;
      }),
    });
  };

  const handleDeleteStep = (index) => {
    const newArray = {...values, locations: values.locations.filter((step, i) => step?._id !== index)}
    setValues(newArray);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      editWorld(values);
    } catch (error) {
      toast.error("Error al actualizar la sección");
    }
  };

  return (
    <div id="wrapperEditInTheWorld" className="wrapperPgi">
      <button onClick={handleShow} className="basePgi__setttings-button">
        <DisplaySettingsOutlined />
      </button>
      <div className="card container containerPgi pt-3 pb-3">
        <InTheWorldReplica />
      </div>

      {/* OFFCANVAS SETTING HOME*/}
      <Offcanvas
        show={showEditProducto}
        onHide={handleClose}
        placement="start"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>EDITAR SECCIÓN EN EL MUNDO</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Tabs
            defaultActiveKey="slide"
            active
            id="productos-tab"
            className="pgi__productos-tab"
          >
            <Tab eventKey="slide" title="En el mundo">
              <form onSubmit={handleSubmit}>
                <button
                  type="submit"
                  className="settings_button-pleno news_button float-end"
                >
                  GUARDAR
                </button>
                <div className="pgi__sidebar-container-items form-group w-100">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      id="title"
                      value={values?.title}
                      onChange={handleInputChange}
                      placeholder="..."
                      required
                      maxLength={200}
                      minLength={2}
                    />
                    <label htmlFor="link2">Titulo</label>
                  </div>

                  <hr />
                  <h3 className="basePgi__comments">Sucursales</h3>
                  <fieldset className="pgi__sidebar-container-items">
                    <p className="basePgi__comments">
                      Desde aquí podrá cargar cada sucursal de la sección.
                    </p>
                    <div className="pgi__archivo pgi__install">
                      {values?.locations &&
                        values?.locations?.map((step, index) => {
                          return (
                            <div className="mx-3" key={step?._id}>
                              <label htmlFor="title">{index + 1}</label>
                              <OverlayTrigger
                                key="1"
                                placement="top"
                                overlay={<Tooltip id="1">Eliminar</Tooltip>}
                              >
                                <Button onClick={() => handleDeleteStep(step?._id)}>
                                  <DeleteForeverOutlined />
                                </Button>
                              </OverlayTrigger>
                              <div className="input-group my-2">
                                <small className="d-block w-100">País</small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`country`}
                                  placeholder="País"
                                  id={step?._id}
                                  defaultValue={step?.country}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>
                              <div className="input-group my-2">
                                <small className="d-block w-100">
                                  Provincia
                                </small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`province`}
                                  placeholder="Provincia"
                                  id={step?._id}
                                  defaultValue={step?.province}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>
                              <div className="input-group my-2">
                                <small className="d-block w-100">
                                  Localidad
                                </small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`locality`}
                                  placeholder="Localidad"
                                  id={step?._id}
                                  defaultValue={step?.locality}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>
                              <div className="input-group my-2">
                                <small className="d-block w-100">
                                  Dirección
                                </small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`address`}
                                  placeholder="Dirección"
                                  id={step?._id}
                                  defaultValue={step?.address}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>

                              <div className="input-group my-2">
                                <small className="d-block w-100">
                                  Código Postal
                                </small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`postal_code`}
                                  placeholder="Código Postal"
                                  id={step?._id}
                                  defaultValue={step?.postal_code}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>
                              <div className="input-group my-2" >
                                <small className="d-block w-100">
                                  Teléfono
                                </small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`phone`}
                                  placeholder="Teléfono"
                                  id={step?._id}
                                  defaultValue={step?.phone}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>
                              <div className="input-group my-2">
                                <small className="d-block w-100">Email</small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`email`}
                                  placeholder="Email"
                                  id={step?._id}
                                  defaultValue={step?.email}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>
                              <div className="input-group my-2">
                                <small className="d-block w-100">Latitud</small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`lat`}
                                  placeholder="Latitud"
                                  id={step?._id}
                                  defaultValue={step?.position?.lat}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>
                              <div className="input-group my-2">
                                <small className="d-block w-100">
                                  Longitud
                                </small>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`lng`}
                                  placeholder="Longitud"
                                  id={step?._id}
                                  defaultValue={step?.position?.lng}
                                  onChange={handleStepInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                              </div>
                              <hr />
                            </div>
                          );
                        })}
                    </div>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Nueva sucursal</Tooltip>}
                    >
                      <Button
                        variant="light"
                        className="btn-form-pgi allW"
                        onClick={handleAddStep}
                      >
                        <AddOutlined />
                      </Button>
                    </OverlayTrigger>
                  </fieldset>
                </div>
              </form>
            </Tab>
            <Tab eventKey="modulos" title="Módulos">
              <form
                id="formEditarHModulos"
                className="basePgi__vista-edit-gral"
              >
                <header aria-labelledby="formEditarHModulos">
                  <h2>Módulos</h2>
                </header>
                <Table responsive className="basePgi__table-list" hover>
                  <colgroup>
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-position" />
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="2" className="basePgi__table-col-min" />
                  </colgroup>
                  <tbody>
                    {
                      // mapeo automatico de tabla de modulos
                      modulesNew?.map((module, index) => {
                        return (
                          module.title !== "TensoNews" && (
                            <>
                              <tr key={index}>
                                <td>
                                  <Button disabled>
                                    <DragHandleOutlined />
                                  </Button>
                                </td>
                                <td className="pgi__table-position-number">
                                  <b>{index + 1}</b>
                                </td>
                                <td className="pgi__module-name">
                                  {module.title}
                                </td>
                                <td>{module.moduleType}</td>
                                {module.title === "Banner_publicitario" ? (
                                  <td>
                                    {arrayBanner?.title
                                      ? arrayBanner?.title
                                      : ""}
                                  </td>
                                ) : (
                                  <td>
                                    {module?.content
                                      ? module.content[index]
                                      : ""}
                                  </td>
                                )}

                                <td>
                                  <OverlayTrigger
                                    key="1"
                                    placement="top"
                                    overlay={
                                      <Tooltip id="1">Visibilidad</Tooltip>
                                    }
                                  >
                                    <Button
                                      className={
                                        module.visible.find(
                                          (item) => item === "world"
                                        )
                                          ? ""
                                          : "disabled"
                                      }
                                      onClick={() =>
                                        handleVisibility(module, "world")
                                      }
                                    >
                                      <VisibilityOutlined />
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                                {module.editable ? (
                                  <td>
                                    {/* <Button><ModeEditOutlined/></Button> */}
                                    {module.title === "Banner_publicitario" && (
                                      <OverlayTrigger
                                        key="1"
                                        placement="top"
                                        overlay={
                                          <Tooltip id="1">Ver banners</Tooltip>
                                        }
                                      >
                                        <Button
                                          onClick={() =>
                                            setSelectBanner(!selectBanner)
                                          }
                                        >
                                          <ArrowForwardIosOutlined />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                     {module.title === "Bloque_info" && (
                                    <OverlayTrigger
                                      key="1"
                                      placement="top"
                                      overlay={
                                        <Tooltip id="1">Ver Bloques</Tooltip>
                                      }
                                    >
                                      <Button
                                        onClick={() =>
                                          setSelectBloque(!selectBloque)
                                        }
                                      >
                                        <ArrowForwardIosOutlined />
                                      </Button>
                                    </OverlayTrigger>
                                  )}
                                  </td>
                                ) : (
                                  <td></td>
                                )}
                              </tr>
                            </>
                          )
                        );
                      })
                    }
                  </tbody>
                </Table>
                <button
                  type="button"
                  className="settings_button-pleno"
                  onClick={handleModuleUpdate}
                >
                  Actualizar Módulos
                </button>
              </form>
              {selectBloque === true && (
            <>
              <hr className="basePgi__space-line" />
              <form
                action=""
                id="formEditarHModulos"
                className="basePgi__vista-edit-gral"
              >
                <header aria-labelledby="formEditarHModulos">
                  <h2>Selecciona los bloques de info</h2>
                </header>
                <Table responsive className="basePgi__table-list" hover>
                  <colgroup>
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="2" className="basePgi__table-col-min" />
                  </colgroup>
                  <tbody>
                    {bloques?.map(
                      (bloque) =>
                        bloque?.deleted === false && (
                          <>
                            <tr key={bloque._id}>
                              <td className="pgi__table-check">
                                <Form.Check
                                  inline
                                  aria-label="banner #id" // indicar x variable el nº id
                                  name="selectBanner"
                                  type="checkbox"
                                  id="align-left"
                                  defaultChecked={bloque.visible.find(
                                    (item) => item === "world"
                                  )}
                                  onClick={() => {
                                    handleVisibilityBloque(bloque._id, "world");
                                  }}
                                />
                              </td>
                              <td>{bloque.title_content}</td>
                            </tr>
                          </>
                        )
                    )}
                  </tbody>
                </Table>
              </form>
            </>
          )}
            </Tab>
          </Tabs>
          {selectBanner === true && (
            <>
              <hr className="basePgi__space-line" />
              <form
                action=""
                id="formEditarHModulos"
                className="basePgi__vista-edit-gral"
              >
                <header aria-labelledby="formEditarHModulos">
                  <h2>Selecciona los banners</h2>
                </header>
                <Table responsive className="basePgi__table-list" hover>
                  <colgroup>
                    <col span="1" className="basePgi__table-col-min" />
                    <col span="1" className="basePgi__table-col-max" />
                    <col span="2" className="basePgi__table-col-min" />
                  </colgroup>
                  <tbody>
                    {banners?.map(
                      (banner) =>
                        banner?.deleted === false && (
                          <>
                            <tr key={banner._id}>
                              <td className="pgi__table-check">
                                <Form.Check
                                  inline
                                  aria-label="banner #id" // indicar x variable el nº id
                                  name="selectBanner"
                                  type="checkbox"
                                  id="align-left"
                                  defaultChecked={banner.section.find(
                                    (item) => item === "world"
                                  )}
                                  onClick={() => {
                                    handleVisibilityBanners(
                                      banner._id,
                                      "world"
                                    );
                                  }}
                                />
                              </td>
                              <td>{banner.title}</td>
                            </tr>
                          </>
                        )
                    )}
                  </tbody>
                </Table>
              </form>
            </>
          )}
          {/****************end lista productos *************************** */}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default InTheWorldPgi;
